import reducer from "./reducers";

import * as labtestattributeAction from "./actions";

export { labtestattributeAction };

export default reducer;
